module.exports = __webpack_public_path__ + "static/media/font.28dd493f.svg";